export default {
  strict: true,
  namespaced: true,
  state: {
    list: [],
    loading: false,
    search: '',
    currentPage: 1,
    perPage: 20,
    order: 'id',
    orderAsc: 0,
    maxList: 0,
    rerender: false,
    showAdd: false
  },
  mutations: {
    setList (state, value) { state.list = value },
    setLoading (state, value) { state.loading = value },
    setSearch (state, value) { state.search = value },
    setCurrentPage (state, value) { state.currentPage = value },
    setPerPage (state, value) { state.perPage = value },
    setOrder (state, value) { state.order = value },
    setOrderAsc (state, value) { state.orderAsc = value },
    setMaxList (state, value) { state.maxList = value },
    updateEnable (state, data) {
      let index = state.list.findIndex(x => x.id === data.id)
      if (index > -1) {
        state.list[index].enabled = data.enable
      }
    },
    setRerender (state, value) { state.rerender = value },
    setShowAdd (state, value) { state.showAdd = value }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/promo/list.js